module.exports = __webpack_public_path__ + "static/media/full-cart.6d964e58.svg";